module.exports = __webpack_public_path__ + "img/default_hero_org_3.0ce1078a.png";